import React, { useEffect, useState } from 'react';
import axios from "axios";
function WalletsReports() {

    const [error, setError] = useState("");
    const [amount, setAmount] = useState("");
    const [month, setMonth] = useState("");
    const [employeesData, setEmployeesData] = useState([]);
    const [selectedIds, setSelectedIds] = useState([]);
    const [selectAll, setSelectAll] = useState(false);



    useEffect(() => {
        const fetchEmployees = async () => {
            const token = localStorage.getItem("authToken"); // ✅ get token from localStorage
            try {
                const storedUserId = localStorage.getItem("professionalUserId");
                if (!storedUserId) {
                    setError("Professional User ID not found in localStorage");
                    return;
                }

                const apiUrl = `https://backend.maamaas.com/subscription/api/user/money/get/transfer/${storedUserId}`;

                const response = await fetch(apiUrl, {
                    headers: {
                        Authorization: token ? `Bearer ${token}` : "", // ✅ correct spelling & use token
                        "Content-Type": "application/json"
                    }
                });

                if (!response.ok) {
                    throw new Error(`Failed to fetch employees. Status: ${response.status}`);
                }

                const data = await response.json();
                console.log("Employees Data Raw:", data);
                console.table(data);

                if (Array.isArray(data)) {
                    setEmployeesData(data);
                } else if (data && data.employees) {
                    setEmployeesData(data.employees);
                } else {
                    setEmployeesData([]);
                }
            } catch (err) {
                console.error("Fetch Employees Error:", err);
                setError("Error fetching employees");
                setEmployeesData([]);
            }
        };

        fetchEmployees();
    }, []);





    return (
        <div>


            {/* Input Section */}


            {/* Table */}
            <table style={tableStyle}>
                <thead>
                    <tr>
                        {/* <th style={tableHeaderStyle}>
                            <input type="checkbox" checked={selectAll} onChange={handleSelectAll} />
                        </th> */}
                        <th style={tableHeaderStyle}>S.No</th>
                        <th style={tableHeaderStyle}> Compamy Name</th>
                        <th style={tableHeaderStyle}>Resturent Nmae</th>
                      
                        <th style={tableHeaderStyle}>Amount</th>
                    </tr>
                </thead>
                <tbody> {employeesData.map((item, index) => (<tr key={item.id}>



                    <td style={tableCellStyle}>{index + 1}</td>
                    <td style={tableCellStyle}>{item.name}</td>
                    <td style={tableCellStyle}>{item.email}</td>
                    {/* <td style={tableCellStyle}>{item.phoneNumber}</td>
                    <td style={{
                        ...tableCellStyle,
                        color: item.postPaid ? "green" : "red",
                        fontWeight: "bold"
                    }}>
                        {item.postPaid ? "POSTPAID" : "PREPAID"}
                    </td>
                    <td style={tableCellStyle}>{item.empid}</td>
                    <td style={tableCellStyle}>{item.userId}</td> */}
                    <td style={tableCellStyle}>{item.amount
                    }</td>
                </tr>))}
                </tbody>
            </table>
        </div >
    );
}

// Styles
const tableStyle = { width: "100%", borderCollapse: "collapse", marginTop: "10px" };
const tableHeaderStyle = { border: "1px solid #ddd", padding: "8px", backgroundColor: "#ee6521", color: "white", textAlign: "center" };
const tableCellStyle = { border: "1px solid #ddd", padding: "6px", textAlign: "center" };
const inputStyle = { padding: "6px", border: "1px solid #ccc", borderRadius: "4px" };
const sendButtonStyle = { padding: "8px 16px", backgroundColor: "green", color: "white", border: "none", borderRadius: "5px", cursor: "pointer" };

export default WalletsReports;
